import React, { useEffect, useState } from 'react';
import { useField, useFormikContext } from 'formik';
import Icons from '../../icons/Icons';

const generateCaptcha = () => {
  const letters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  let captcha = '';

  for (let i = 0; i < 3; i++) {
    captcha += letters.charAt(Math.floor(Math.random() * letters.length));
  }

  for (let i = 0; i < 3; i++) {
    captcha += numbers.charAt(Math.floor(Math.random() * numbers.length));
  }

  return captcha
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('');
};

const CaptchaField = ({ 
  name, 
  onChangeCb, 
  isServerCaptcha = false,
  captchaData = '',
  isCaptchaLoading = false,
  onRefreshCaptcha = null,
  disabled = false
}) => {
  const [captchaValue, setCaptchaValue] = useState('');
  const { setFieldValue, values } = useFormikContext();
  const [field, meta] = useField(name);

  useEffect(() => {
    if (!isServerCaptcha) {
      const newCaptcha = generateCaptcha();
      setCaptchaValue(newCaptcha);
      setFieldValue('captchaCode', newCaptcha);
    }
  }, [setFieldValue, isServerCaptcha]);

  const reloadCaptcha = () => {
    if (isServerCaptcha && onRefreshCaptcha) {
      onRefreshCaptcha();
    } else {
      const newCaptcha = generateCaptcha();
      setCaptchaValue(newCaptcha);
      setFieldValue('captchaCode', newCaptcha);
      setFieldValue(name, '');
    }
  };

  return (
    <div className="pt-4 text-left">
      <label className="block font-semibold text-sm mb-1">CAPTCHA <span className="text-red-500">*</span></label>
      <div className="flex items-center gap-2">
        <div className="text-xl tracking-widest bg-gray-100 px-4 py-2 border rounded line-through italic font-semibold font-mono select-none" onCopy={(e)=> e.preventDefault()}>
          {isServerCaptcha ? (isCaptchaLoading ? "Loading..." : captchaData) : captchaValue}
        </div>
        <button
          type="button"
          onClick={reloadCaptcha}
          className="text-sm text-blue-600 underline self-end"
          disabled={isCaptchaLoading}
        >
          <Icons iconName={"reLoadIcon"} />
        </button>
      </div>
      <input
        {...field}
        placeholder="Enter CAPTCHA"
        className="mt-2 w-full border px-3 py-2 rounded outline-none focus:ring-1 ring-blue-300"
        onChange={onChangeCb}
        onPaste={(e)=> e.preventDefault()}
        disabled={disabled || isCaptchaLoading}
      />
      {!isServerCaptcha && meta.touched && meta.error && (
        <div className="text-sm text-red-500 mt-1">{meta.error}</div>
      )}
    </div>
  );
};

export default CaptchaField;


